module.exports = __webpack_public_path__ + "static/mo22-dd5031982535ddb14ee338bd1a58dd70.png";